import { Instagram } from "lucide-react";
import { SectionHead, FadeUp } from "./Reveal";

export const Foundation = () => (
  <section id="foundation" className="relative py-24 lg:py-32 overflow-hidden" data-testid="foundation-section">
    <div className="spotlight pointer-events-none absolute top-0 left-1/2 h-[36rem] w-[46rem] -translate-x-1/2 rounded-full" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <FadeUp>
        <div className="relative overflow-hidden rounded-3xl border border-gold/30 bg-gradient-to-b from-gold/10 via-gold/5 to-transparent p-8 sm:p-12 lg:p-16 text-center">
          <span className="pointer-events-none absolute inset-x-0 -bottom-10 font-serif font-light text-[clamp(5rem,16vw,13rem)] leading-none tracking-tight text-gold/10 select-none" aria-hidden="true">
            NSEYA
          </span>

          <p className="eyebrow justify-center flex items-center gap-3">
            <span className="inline-block h-px w-10 bg-gold/60" aria-hidden="true" />
            Giving back, warmly
            <span className="inline-block h-px w-10 bg-gold/60" aria-hidden="true" />
          </p>

          <div className="mt-10 flex flex-col items-center" data-testid="foundation-logo">
            <div className="rounded-2xl bg-ivory p-3 shadow-[0_18px_60px_rgba(212,175,55,0.25)] transition-transform duration-500 hover:scale-[1.03]">
              <img
                src="/images/nseya-logo.png"
                alt="Nseya Humanitarian Foundation — Change for Congo logo"
                className="h-44 w-40 sm:h-52 sm:w-48 object-contain"
                loading="lazy"
              />
            </div>
            <span className="mt-8 h-px w-24 bg-gold/50" aria-hidden="true" />
          </div>

          <h2 className="mt-10 mx-auto max-w-3xl font-serif text-3xl sm:text-4xl lg:text-5xl font-light leading-tight text-ivory">
            Every booking gives back. <em className="italic text-gold">Every session builds a sanctuary.</em>
          </h2>

          <p className="mt-6 mx-auto max-w-2xl text-mute text-base sm:text-lg leading-relaxed">
            A portion of every booking supports the Nseya Humanitarian Foundation —
            bringing safety, healing and opportunity to women and children whose lives
            need it most. When you care for your people, you help care for theirs.
          </p>

          <p className="mt-6 mx-auto max-w-2xl text-ivory/90 text-sm sm:text-base" data-testid="foundation-note">
            A portion of every booking supports the Nseya Humanitarian Foundation — visit{" "}
            <a
              href="https://www.nseyafoundation.org"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="foundation-link"
              className="text-gold underline underline-offset-4 decoration-gold/40 hover:text-ivory transition-colors"
            >
              www.nseyafoundation.org
            </a>{" "}
            to learn more.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4" data-testid="foundation-links">
            <a
              href="https://instagram.com/danceforcongo"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="foundation-instagram-link"
              className="inline-flex items-center gap-2.5 rounded-full border border-gold/40 px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.18em] text-gold transition-all duration-300 hover:bg-gold hover:text-ink"
            >
              <Instagram className="h-4 w-4" aria-hidden="true" />
              @danceforcongo
            </a>
            <a
              href="https://www.nseyafoundation.org"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="foundation-cta"
              className="inline-flex items-center gap-3 rounded-full bg-gold px-6 py-2.5 font-mono text-[10px] uppercase tracking-[0.18em] font-medium text-ink transition-all duration-300 hover:bg-ivory hover:shadow-[0_0_44px_rgba(212,175,55,0.4)]"
            >
              Visit the Foundation →
            </a>
          </div>
        </div>
      </FadeUp>
    </div>
  </section>
);
